angular.module('unergie.main')
.controller('complaintsCtrl', ($q, $scope, $state, $stateParams, JiraService, JiraConstants, AlertManager, NgTableParams,
    ApiAdmin, ErrorCatcher, DataAccess, BoFeaturesService, FileUploader, ModalService) => {
    $scope.isComplaintsFeatureOn = (feature) => BoFeaturesService.getModuleFeatures('complaints')[feature]
    $scope.complaints = null
    $scope.jira_status_mapping = $q.defer()
    $scope.jira_resolution_mapping = $q.defer()
    $scope.level_mapping = $q.defer()
    const hoursPerDay = 10

    const setDropdownFilterMappings = (issues) => {
        $scope.jira_status_mapping.resolve(_.uniqBy([{ id: '', title: 'Tous' }].concat(_.map(issues, (issue) => ({
            id: issue.fields.status.id,
            title: issue.fields.status.name,
        }))), 'id'))
    }

    const setDropdownResolutionMappings = (issues) => {
        $scope.jira_resolution_mapping.resolve(_.uniqBy([{ id: '', title: 'Tous' }].concat(_.map(issues, (issue) => ({
            id: issue.fields.resolution ? issue.fields.resolution.name : 'null',
            title: issue.fields.resolution ? issue.fields.resolution.description : 'En cours',
        }))), 'id'))
    }

    const setDropdownLevelMappings = (issues) => {
        $scope.level_mapping.resolve(_.uniqBy([{ id: '', title: 'Tous' }].concat(_.map(issues, (issue) => ({
            id: issue.fields.complaintLevel ? issue.fields.complaintLevel.value : '',
            title: issue.fields.complaintLevel ? issue.fields.complaintLevel.value : '',
        }))), 'id'))
    }

    const calculDays = (timeToResolution) => {
        if (timeToResolution.ongoingCycle) {
            let sign = ''
            let color = 'bluegrey'
            if (timeToResolution.ongoingCycle.remainingTime.millis <= 0) {
                sign = '-'
                color = 'dark-pink'
            }
            const decimalDays = Math.abs(timeToResolution.ongoingCycle.remainingTime.millis) / 1000 / 60 / 60 / hoursPerDay
            const days = Math.trunc(decimalDays)
            if (days >= 3 || days <= -3) {
                return { value: `${sign}${days}j`, color }
            }
            const decimalHours = (decimalDays - days) * hoursPerDay
            const hours = Math.trunc(decimalHours)
            if (days >= 1 || days <= -1) {
                return { value: `${sign}${days}j ${hours}h`, color }
            }
            const minutes = Math.trunc((decimalHours - hours) * 60)
            return { value: `${sign}${hours}h ${minutes}m`, color }
        }
        return { value: '-', color: 'dark-green' }
    }


    const refresh = (params) => {
        $scope.refreshing = true
        const jiraParams = _.assign({}, params)
        jiraParams.filter = () => _.assign({}, params.filter())
        return JiraService.getData(jiraParams, 'complaints',
            'channel,key,issuetype,idContract,idCustomer,clientName,complaintLevel,created,summary,status,resolution,timeToResolution,resolutiondate'
        ).$promise.then((response) => {
            const result = response.results
            $scope.complaints.total = () => result.total
            const complaintMap = _.map(result.issues, (issue) => {
                return {
                    channel: issue.fields.channel,
                    key: issue.key,
                    issueIcon: issue.fields.issuetype.iconUrl,
                    idContract: issue.fields.idContract,
                    idCustomer: issue.fields.idCustomer,
                    clientName: issue.fields.clientName,
                    complaintLevel: issue.fields.complaintLevel ? issue.fields.complaintLevel.value : '',
                    created: moment(issue.fields.created).format('DD/MM/YYYY HH:mm'),
                    summary: issue.fields.summary,
                    status: issue.fields.status.name,
                    resolution: issue.fields.resolution ? issue.fields.resolution.description : 'En cours',
                    remainingDays: calculDays(issue.fields.timeToResolution),
                    resolutiondate: issue.fields.resolutiondate ? moment(issue.fields.resolutiondate).format('DD/MM/YYYY HH:mm') : '-',
                }
            })
            setDropdownFilterMappings(result.issues)
            setDropdownLevelMappings(result.issues)
            setDropdownResolutionMappings(result.issues)
            $scope.complaints.data = complaintMap

            return complaintMap
        })
        .catch((err) => {
            $scope.complaints.data = null
            console.error(err)
            return AlertManager.error(_.get(err, 'data.results.error.errorMessages[0]') || 'Une erreur est intervenue lors de l’appel a JIRA', 5000)
        })
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.renderTable = (init = false) => {
        let filter
        if (init && $stateParams.id_contract) {
            filter = { idContract: $stateParams.id_contract }
        } else if (init && $stateParams.key) {
            filter = { key: $stateParams.key }
        } else {
            filter = ($scope.complaints != null ? $scope.complaints.filter() : undefined) || {}
        }
        $scope.complaints = new NgTableParams({
            count: ($scope.complaints != null ? $scope.complaints.count() : undefined) || 12,
            filter,
            sorting: ($scope.complaints != null ? $scope.complaints.sorting() : undefined) || { created: 'desc' },
        }, {
            counts: [12, 25, 50, 100],
            getData: refresh,
        })
    }

    $scope.expandComplaint = (datum) => {
        if (datum) {
            if (!datum.expanded) {
                datum.refreshing = true
                datum.expanded = !datum.expanded
                return ApiAdmin.getJiraStatusHistoryAndPublicComments({ idIssue: datum.key }).$promise
                .then((jiraResponse) => {
                    datum.issue = jiraResponse.fields
                    datum.issue.simpleInitiator = jiraResponse.fields.initiator.replace(/@.*/, '')
                    datum.history = jiraResponse.history
                    datum.publicComments = _.orderBy(jiraResponse.publicComments.map((comment) => {
                        return _.assign({}, comment, {
                            displayedBody: JiraService.attachmentCommentCleaner(comment.body),
                        })
                    }), 'created', 'desc')
                    datum.attachments = _.orderBy(jiraResponse.attachments.map((attachment) => {
                        return _.assign({}, attachment, {
                            displayedFilename: attachment.filename.replace(/^(public_|internal_)/, ''),
                            isInternal: !attachment.filename.startsWith('public_'),
                        })
                    }), 'created', 'desc')

                    return DataAccess.contract({ id: datum.idContract }).$promise
                    .catch(() => {
                        return DataAccess.getDraftById({ idDraft: datum.idContract }).$promise
                    })
                    .catch((err) => {
                        console.error(err)
                        return AlertManager.error('Une erreur est intervenue lors de la récupération du contrat', 5000)
                    })
                }).then((contractElec) => {
                    datum.contractElec = contractElec
                    datum.refreshing = false
                })
            }
            datum.expanded = !datum.expanded
        }
    }

    $scope.setSelectedComplaint = (selectedComplaint) => {
        $scope.selectedComplaint = selectedComplaint
    }

    $scope.publicAttachmentUploader = new FileUploader({
        method: 'POST',
        autoUpload: true,
        formData: [{ isPublic: true }],
        onErrorItem(item, response, status, headers) {
            return ErrorCatcher(response)
        },
        onAfterAddingFile(item) {
            item.url = `/api-admin/jira/servicedesk/project/complaints/issue/${$scope.selectedComplaint.key}/add/file`
        },
        onCompleteAll() {
            AlertManager.success('Pièces jointes enregistrées.')
            $scope.selectedComplaint.expanded = false
            $scope.expandComplaint($scope.selectedComplaint)
        },
    })

    $scope.privateAttachmentUploader = new FileUploader({
        method: 'POST',
        autoUpload: true,
        formData: [{ isPublic: false }],
        onErrorItem(item, response, status, headers) {
            return ErrorCatcher(response)
        },
        onAfterAddingFile(item) {
            item.url = `/api-admin/jira/servicedesk/project/complaints/issue/${$scope.selectedComplaint.key}/add/file`
        },
        onCompleteAll() {
            AlertManager.success('Pièces jointes enregistrées.')
            $scope.selectedComplaint.expanded = false
            $scope.expandComplaint($scope.selectedComplaint)
        },
    })

    $scope.openJiraCommentsModal = (event, issue) => {
        event.preventDefault()
        event.stopPropagation()
        ModalService.openModal({ type: 'jiraCommentsModal', size: 'lg' }, { idJira: issue.key, issueType: 'complaint', readOnly: false })
    }

    $scope.openProcessComplaintModal = (event, issue) => {
        event.preventDefault()
        event.stopPropagation()
        ModalService.openModal({ type: 'processComplaintModal', size: 'lg' }, { complaint: issue }, () => {
            $scope.renderTable()
        })
    }

    $scope.renderTable(true)
})
